<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar title="交易记录">
      </black-bar>
    </div>
    <!-- <div class="cardInfo">
      <div class="li">
        <span class="key">卡号：</span>
        <span class="val">{{cardInfo.printNo}}</span>
      </div>
      <div class="li">
        <span class="key">余额：</span>
        <span class="val">{{cardInfo.balance/100}}元</span>
      </div>
    </div> -->
    <ul class="title">
      <li v-for="(item,index) in typeList"
          :key="index"
          :class="index==typeNum?'checked':''"
          @click="selectItem(index)">{{item}}</li>
    </ul>
    <div v-if="typeNum == 0">
      <ul class="trading-list"
          v-for="(item,index) in tradingList"
          :key="index">
        <li>
          <div class="key">卡号</div>
          <div class="val">{{cardInfo.printNo}}</div>
        </li>
        <!-- <li>
          <div class="key">乘车方式</div>
          <div class="val">暂无</div>
        </li> -->
        <li>
          <div class="key">消费金额</div>
          <div class="val">{{item.tradeAmount/100}}元</div>
        </li>
        <li>
          <div class="key">消费类型</div>
          <div class="val">{{item.tradeType}}</div>
        </li>
        <!-- <li>
          <div class="key">交易状态</div>
          <div class="val">暂无</div>
        </li> -->
        <li>
          <div class="key">消费时间</div>
          <div class="val">{{item.tradeDate}} {{item.tradeTime}}</div>
        </li>
      </ul>

    </div>
    <div v-else>
      <ul class="order-list"
          v-for="(item,index) in orderLists"
          :key="index">
        <div class="li-title">
          <!-- <img src="../assets/img/icon_dd.png" alt=""> -->
          <div class="key">订单号：</div>
          <div class="val">{{item.orderno}}</div>
          <div class="li-status">{{item.refundst}}</div>
        </div>
        <li>
          <div class="key">充值金额</div>
          <div class="val">{{item.txnamt/100}}元</div>
        </li>
        <li>
          <div class="key">充值方式</div>
          <div class="val">{{item.paytype}}</div>
        </li>
        <li>
          <div class="key">充值状态</div>
          <div :class="['val', item.state === '充值成功' ? 'val-balck' : 'val-red']">{{item.state}}</div>
        </li>
        <li>
          <div class="key">充值时间</div>
          <div class="val">{{item.txndate}} {{item.txntime}}</div>
        </li>
      </ul>

    </div>

  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
export default {
  name: 'orderList',
  data () {
    return {
      loading: true,
      typeList: ['消费记录', '订单记录'],
      typeNum: 0,
      tradingList: [
        // {
        //   cardNo: "",
        //   type: "",
        //   tradeType: "",
        //   tradeStatus: "",
        //   tradeTime: "",
        //   tradeMoney: ""
        // },

        // {
        //   cardNo: "1234567890",
        //   type: "公交一",
        //   tradeType: "消费",
        //   tradeStatus: "已扣款",
        //   tradeTime: "2022-04-14 15:07:45",
        //   tradeMoney: "1.60"
        // },
        // {
        //   cardNo: "1234567890",
        //   type: "公交二",
        //   tradeType: "消费",
        //   tradeStatus: "已扣款",
        //   tradeTime: "2022-04-14 15:07:45",
        //   tradeMoney: "1.60"
        // },
      ],
      orderLists: [
        // {
        //   cardNo: "YYYYYYYYYY",
        //   type: "1.60",
        //   tradeType: "充值成功",
        //   tradeStatus: "2022-04-14  15:07:45 ",
        //   tradeTime: "2022-04-14 15:07:45",
        //   tradeMoney: "支付宝"
        // },
        // {
        //   cardNo: "YYYYYYYYYY",
        //   type: "1.60",
        //   tradeType: "充值失败",
        //   tradeStatus: "2022-04-14  15:07:45 ",
        //   tradeTime: "2022-04-14 15:07:45",
        //   tradeMoney: "支付宝"
        // },
      ],
      cardInfo: {},




    }
  },
  components: {
    blackBar
  },
  created () {


  },
  mounted () {
    this.cardInfo = this.$route.params.cardInfo
    const that = this;
    window.orderList = that.orderList;


  },
  created () {

    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  methods: {
    orderList (val) {
      // this.textList = val.data.recordBean.transactionRecord;
      if (val.code == '0000') {
        this.orderLists = val.data.recordBean.orderRecord;
        this.tradingList = val.data.recordBean.transactionRecord;
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: val.message
        })
      }
    },

    selectItem (index) {
      this.typeNum = index;
    },
    goRouter (router) {
      if (this.loading) {
        this.$router.push({
          name: router
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
  background-color: #f5f5f5;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
  img {
    width: 100%;
  }
}
.cardInfo {
  width: calc(92% - 64px);
  margin-left: 4%;
  margin-top: 16px;
  height: 96px;
  padding: 32px;
  background: #4a8ef7;
  border-radius: 16px 16px 16px 16px;
  .li {
    display: flex;
    height: 40px;
    line-height: 40px;
    font-size: 28px;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 16px;
    .key {
      width: 100px;
      text-align: left;
    }
    .val {
      width: calc(100% - 100px);
      text-align: right;
    }
  }
}
.title {
  width: 92%;
  margin: 0px 0 10px 4%;
  // margin-left: 4%;
  display: flex;
  align-items: center;
  font-size: 32px;
  font-weight: 400;
  color: #282b29;
  li {
    width: 50%;
    height: 95px;
    line-height: 95px;
    text-align: center;
  }
  .checked {
    font-weight: 500;
    color: #4a8ef7;
  }
  .checked::after {
    width: 128px;
    content: "";
    display: block;
    margin: -20px auto;
    border-bottom: 8px solid #4a8ef7;
  }
}
.trading-list {
  width: calc(92% - 64px);
  margin-left: 4%;
  padding: 24px 32px;
  // height: 298px;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  li {
    display: flex;
    height: 56px;
    font-size: 28px;
    .key {
      width: 130px;
      line-height: 56px;
      text-align: left;
      color: #999999;
    }
    .val {
      width: calc(100% - 130px);
      line-height: 56px;
      text-align: right;
      color: #333333;
    }
    .val-black {
      color: #282b29;
    }
    .val-red {
      color: red;
    }
  }
  li:last-child() {
    margin-bottom: 0px;
  }
}
.order-list {
  width: 92%;
  margin: 16px 4%;
  padding-bottom: 32px;
  // height: 298px;
  background: #ffffff;
  border-radius: 16px 16px 16px 16px;
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  .li-title {
    display: flex;
    height: 96px;
    margin-left: 32px;
    margin-right: 32px;
    margin-bottom: 8px;
    line-height: 96px;
    border-bottom: 1px dashed #dcdcdc;
    font-size: 28px;
    font-weight: 500;
    .key {
        width: 120px;
        // height: 40px;
        line-height: 88px;
        margin-top: 8px;
        text-align: left;
        color: #333;
      }
      .val {
        width: calc(100% - 220px);
        line-height: 88px;
        margin-top: 8px;
        text-align: left;
        color: #333;
      }
      .li-status {
        width: 90px;
        line-height: 88px;
        margin-top: 8px;
        text-align: right;
        color: #F28D37;
        font-weight: 400;
      }
  }
  li {
    display: flex;
    height: 40px;
    font-size: 28px;
    margin: 16px 32px 0 32px;
    .key {
      width: 130px;
      line-height: 40px;
      text-align: left;
      color: #999999;
    }
    .val {
      width: calc(100% - 130px);
      line-height: 40px;
      text-align: right;
      color: #333333;
    }
    .val-black {
      color: #282b29;
    }
    .val-red {
      color: red;
    }
  }
  li:last-child() {
    margin-bottom: 0px;
  }
}
</style>
